import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const Night: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <path
                fill="currentColor"
                d="M7.4,0c-.8,1.2-1.3,2.5-1.3,4,0,3.9,3.2,7,7.2,7s1.8-.2,2.7-.5c-1.1,3.2-4.2,5.5-7.8,5.5S0,12.4,0,8,3.3.4,7.4,0Z"
            />
        </Icon>
    );
};
